import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import 'swiper/css/swiper.css';
import './assets/css/public.css';
// import './assets/js/three.min';
import './assets/js/vanta.birds.min';

//图片预览
import VuePhotoPreview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(VuePhotoPreview)

import BackToTop from '@/components/BackToTop.vue'
Vue.component('BackToTop', BackToTop)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js